import request from '@/utils/request'

// 查询列表
export function list(query) {
  return request({
    url: '/power/log/oper/pageList',
    method: 'get',
    params: query,
  })
}

// 日志导出
export function logExport() {
  return '/power/log/oper/export'
}
